<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
  computed: {
    disabled(){
      return this.module.isDefault;
    }
  }
};
</script>
<template>
  <FBody
    type="line"
    :module="module"
    @submit="$emit('submit')"
  >
    <FItem
      :module="module.name"
    />
    <FItem
      :module="module.adult"
      width="80px"
      shrink="0"
    />
    <FItem
      :module="module.child"
      width="80px"
      shrink="0"
    />
    <FItem
      :module="module.age"
      width="80px"
      shrink="0"
      title="До скольки лет детей действует тариф"
    />
    <FItem
      :module="module.netto"
      width="120px"
      shrink="0"
    />
    <FItem
      :module="module.agency"
      width="120px"
      shrink="0"
    />
    <FItem
      :module="module.brutto"
      width="120px"
      shrink="0"
    />
    <FBtn
      icon="el-icon-delete"
      width="24px"
      shrink="0"
      title="Удалить"
      @click="$emit('remove', module)"
    />
  </FBody>
</template>
<style lang="scss">

</style>
